import React, { Component, ReactNode } from 'react';
import { Platform, WriteDirection } from 'sofa-reborn-react';
import SkapaInlineMessage from '@ingka/inline-message';
import InformationCircleIconPaths from '@ingka/ssr-icon/paths/information-circle';
import { localeService } from '../../services';
import styled from 'styled-components';

const InlineMessageWrapper = styled.div<{
	bottom: string;
	top: string;
	left: string;
	platform: Platform;
	extendWidth: boolean;
}>`
	position: absolute;
	bottom: ${(props) => props.bottom};
	top: ${(props) => props.top};
	left: ${(props) => props.left};
	max-width: ${(props) =>
		props.platform === 'kiosk' ? '400px' : props.extendWidth ? '340px' : '280px'};
	z-index: 5;
`;

type Props = {
	platform: Platform;
	writeDirection: WriteDirection;
	top: string;
	left: string;
	bottom: string;
	extendWidth: boolean;
	text: string;
	showButtons: boolean;
	alert?: boolean;
	negative?: boolean;
	onKeepUnfinished?: () => void;
	onRemoveUnfinished?: () => void;
	onClose?: () => void;
};

/**
 * React component.
 *
 */
export default class Popover extends Component<Props> {
	/**
	 * React render method.
	 *
	 * @returns React node.
	 */
	public render(): ReactNode {
		const { props } = this;
		const { onKeepUnfinished, onRemoveUnfinished, onClose } = props;

		return (
			<InlineMessageWrapper
				bottom={props.bottom}
				top={props.top}
				left={props.left}
				platform={props.platform}
				extendWidth={props.extendWidth}
			>
				<SkapaInlineMessage
					id={'inlineMessage'}
					variant={props.alert ? 'cautionary' : props.negative ? 'negative' : 'informative'}
					body={props.text}
					labelCloseButton={localeService.getTranslation('popUpClose')}
					ssrIcon={!props.alert && !props.negative ? InformationCircleIconPaths : undefined}
					dismissable={true}
					onDismissClick={(): void => onClose && onClose()}
					actions={
						props.showButtons
							? [
									{
										text: localeService.getTranslation('popupButtonKeep'),
										onClick: () => onKeepUnfinished && onKeepUnfinished(),
									},
									{
										text: localeService.getTranslation('tooltipDelete'),
										onClick: () => onRemoveUnfinished && onRemoveUnfinished(),
									},
							  ]
							: undefined
					}
				/>
			</InlineMessageWrapper>
		);
	}
}
